<div [class]="theme ? theme : 'one-portal'">
  <div class="">
    <p>
      You are saving your work temporarily. When you want to continue please come back to this page and to finish the
      return process. Once you are finished click “Mark Complete” to submit your return.
    </p>
  </div>
  <div class="button-container btn-group">
    <!--button mat-button class="btn btn-secondary" (click)="closeDialog(false)">Cancel</button-->
    <button mat-button class="btn btn-primary" type="submit" (click)="closeDialog(true)">
      Save
    </button>
  </div>
</div>
